import React from 'react'
import styles from './BlockButton.module.css'

type variant = 'primary' | 'secondary' | 'outline'
type size = 'sm' | 'md' | 'lg' | 'block'

interface BlockButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string
  loading?: boolean
  disabled?: boolean
  variant?: variant
  size?: size
  children?: React.ReactNode
}

export default function BlockButton({
  // className,
  // variant,
  // size,
  loading = false,
  disabled,
  children,
  ...props
}: BlockButtonProps) {
  return (
    <button
      className={
        'inline-flex items-center justify-center rounded-full font-bold w-full h-12 text-base border-0 text-white ' +
        styles.bg
      }
      {...props}
      disabled={disabled ?? loading}>
      {loading ? (
        <>
          <span className="mr-2 h-4 w-4 animate-spin" />
          <span>{children ?? '加载中...'}</span>
        </>
      ) : (
        (children ?? '立即购买')
      )}
    </button>
  )
}
